import api from "./axiosConfig"; 

// Obtener todos los usuarios
// (2026-05-13) Soporta paginacion + filtros nuevos: include_inactive (legacy),
// activo (true/false explicito), tipo_usuario ('interno'|'cliente'), rol, nombre_like, email_like.
export const getCompanyUsers = async (params = {}) => {
  try {
    const query = new URLSearchParams();

    if (params.page != null) query.append("page", params.page);
    if (params.per_page != null) query.append("per_page", params.per_page);
    if (params.request_type) query.append("request_type", params.request_type);
    if (params.include_inactive != null) query.append("include_inactive", params.include_inactive);
    if (params.activo != null) query.append("activo", params.activo);
    if (params.tipo_usuario) query.append("tipo_usuario", params.tipo_usuario);
    if (params.rol) query.append("rol", params.rol);
    if (params.nombre_like) query.append("nombre_like", params.nombre_like);
    if (params.email_like) query.append("email_like", params.email_like);

    const response = await api.get(`/api/company-users?${query.toString()}`);
    return response.data; // Retorna los datos directamente
  } catch (error) {
    console.error("Error fetching company users:", error);
    throw error; // Lanzamos el error para que el componente lo maneje
  }
};

export const showCompanyUsers = async (id) => {
  try {
    const response = await api.get(`/api/company-users/${id}`);
    return response.data; // Retorna los datos directamente
  } catch (error) {
    console.error("Error fetching company users:", error);
    throw error; // Lanzamos el error para que el componente lo maneje
  }
};

// Editar cliente
// (2026-05-25 v14) Ahora retorna el axios response COMPLETO (no `.data`)
// para alinear con el contrato de createCompanyUsers — el handleSubmit de
// FormCompanyUsers.js verifica `data.status` que solo existe en el response
// completo. Antes este retornaba solo `.data`, generando que `data.status`
// fuera undefined y la verificación `!= 200 && != 201` siempre fallara →
// toast.error con "undefined - undefined" aún para edits exitosos.
export const editCompanyUsers = async (id, body) => {
  try {
    const authData = localStorage.getItem("authData");
    if (authData) {
      const { rol } = JSON.parse(authData);
      var response;
      response = await api.put(`/api/company-users/${id}`, body);
      return response;
    }
  } catch (error) {
    console.error("Error al editar el usuario:", error);
    throw error;
  }
};

// Crear un usuario
export const createCompanyUsers = async (body, client_id=false) => {
  try {
    var response;
    if (client_id === false){
      response = await api.post(`/api/company-users`, body);
    }else if (client_id === null){
      response = await api.post(`/admin/users`, body);
    }else{
      response = await api.post(`/admin/empresas/${client_id}/users`, body);
    }
    return response;
  } catch (error) {
    console.error("Error al crear el usuario:", error);
    return error;
  }
};

// Delete a Usuario
export const deleteCompanyUser = async (id) => {
  const response = await api.delete(`/api/company-users/${id}`);
  return response.data;
};

export const activateCompanyUser = async (id) => {
  try {
    const response = await api.put(`/api/company-users/${id}/activar`);
    //console.log('activateProduct-response: ', response);
    return response.data;
  } catch (error) {
    console.error("Error al activar el usuario:", error);
    throw error;
  }
}